import { render, staticRenderFns } from "./newPay.vue?vue&type=template&id=6f5207e4&scoped=true&"
import script from "./newPay.vue?vue&type=script&lang=js&"
export * from "./newPay.vue?vue&type=script&lang=js&"
import style0 from "./newPay.vue?vue&type=style&index=0&id=6f5207e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5207e4",
  null
  
)

export default component.exports